import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const updateCleanerVisibility = async (disabled: boolean) => {
  return await apiClient.patch(`${ENDPOINTS.CLEANERS}/visibility`, {
    disabled,
  });
};
